import React from "react";

import styles from "./Caption.css";

export default function Caption(props) {
  return (
    <figcaption className={styles.caption}>{props.children}</figcaption>
  );
}

